import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IProductTextPutDtoModels } from "../../models/product/dto/text/product-text-put-dto.model";
import { IProductTextGetDtoModels } from "../../models/product/dto/text/product-text-get-dto.model";
import { EnvironmentService } from "../environment.service";

@Injectable({
    providedIn: 'root'
})
export class ProductTextService {
    fullPath: string;
    constructor(private readonly httpClient: HttpClient, public envService: EnvironmentService) {
        this.fullPath = `${envService.settings.apiUrl}/Products`;
    }

    public update(model: IProductTextPutDtoModels): Observable<IProductTextPutDtoModels> {
        return this.httpClient.put<IProductTextPutDtoModels>(`${this.fullPath}/${model.id}/text`, model);
    }

    public get(id: number): Observable<IProductTextGetDtoModels> {
        return this.httpClient.get<IProductTextGetDtoModels>(`${this.fullPath}/${id}/text`);
    }
}